import { Outlet, createFileRoute, useLocation } from '@tanstack/react-router';

import LoginBase from 'component/view/Auth/LoginBase';

export const Route = createFileRoute('/login')({
  component: LoginRoute,
});

function LoginRoute() {
  const { pathname } = useLocation();

  if (pathname === '/login' || pathname === '/login/') {
    return <LoginBase />;
  }

  return <Outlet />;
}
